import type { BlockOptionDefinition } from '#blokkli/types/blokkOptions'

type GlobalOptionsDefaults = {
  type: BlockOptionDefinition['type']
  default: any
}

export const bundlesWithVisibleLanguage: string[] = []
export const bundlesWithHiddenGlobally: string[] = []

export const globalOptionsDefaults: Record<string, GlobalOptionsDefaults> = {
  "bkVisibleLanguages": {
    "default": [],
    "type": "checkboxes"
  },
  "spacingTop": {
    "default": "pt-0",
    "type": "radios"
  },
  "spacingBottom": {
    "default": "pb-100",
    "type": "radios"
  },
  "backgroundColor": {
    "default": "white",
    "type": "radios"
  },
  "layout": {
    "default": "left",
    "type": "radios"
  },
  "stripe": {
    "default": "none",
    "type": "radios"
  }
} as const